import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home/Home";
import Header from "./components/Common-features/Header";
import About from "./components/About/About";
import Career from "./components/Career/Career";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Common-features/Footer";
import ScrolltoTop from "./components/Common-features/ScrolltoTop";
import CaseStudies from "./components/CaseStudies/CaseStudies";
import OpentoTop from "./components/Common-features/OpentoTop";
import GetInTouch from "./components/GetIn-Touch/GetInTouch";
import CaseStudiesOptimizing from "./components/CaseStudies-optimizing/CaseStudiesoptimizing";
import CaseStudiesStreamlining from "./components/CaseStudies-streamlining/CaseStudiesstreamlining";
import CaseStudiesEnhancing from "./components/CaseStudies-enhancing/CaseStudiesenhancing";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import IOSAppDevelopment from "./components/IOS-App-development/IOSAppDevelopment";
import AndroidDevelopment from "./components/Android-App-development/AndroidDevelopment";
import TechConsultation from "./components/Tech-Consultation/TechConsultation";
import DataClassificationPlatform from "./components/Data-Classification-Platform/DataClassificationPlatform";
import DataLossPrevention from "./components/Data-Loss-Prevention/DataLossPrevention";
import CaseStudiesEnhancingLogisticsEfficiency from "./components/CaseStudies-enhancing-logistics-efficiency/CaseStudiesEnhancingLogisticsEfficiency";
import LendingLab from "./components/Lending-Lab/LendingLab";
import DriveAssure from "./components/Drive-Assure/DriveAssure";
import ChoiceTouch from "./components/Choice-Touch/ChoiceTouch";
import CustomerEngagement from "./components/Customer-Engagement/CustomerEngagement";
import TransTrack from "./components/Trans-Track/TransTrack";
import ProcurementProcess from "./components/Procurement-Process/ProcurementProcess";
import SimplifyingInvoicing from "./components/Simplifying-Invoicing/SimplifyingInvoicing";
import PrimeEmpowering from "./components/Prime-Empowering/PrimeEmpowering";
import WebDevelopment from "./components/Web-development/WebDevelopment";
import RedTeaming from "./components/Red-Teaming/RedTeaming";
import RequestDemo from "./components/Request-Demo/RequestDemo";
import ApplyForm from "./components/Apply-Form/ApplyForm";

function Routing() {
  return (
    <Router>
      <OpentoTop />
      <ScrolltoTop />
      <Header />
      <div className="">
        <Routes>
          <Route exact path="/" element={<Home></Home>} />

          <Route exact path="/about-us" element={<About />} />

          <Route exact path="/career" element={<Career />} />

          <Route exact path="/contact-us" element={<Contact />} />

          <Route
            exact
            path="/services/ios-app-development"
            element={<IOSAppDevelopment />}
          />

          <Route
            exact
            path="/services/android-app-development"
            element={<AndroidDevelopment />}
          />

          <Route
            exact
            path="/services/tech-consulting-services"
            element={<TechConsultation />}
          />

          <Route
            exact
            path="/services/data-loss-protection"
            element={<DataLossPrevention />}
          />

          <Route
            exact
            path="/services/data-classification-platform"
            element={<DataClassificationPlatform />}
          />

          <Route
            exact
            path="/services/red-teaming-services"
            element={<RedTeaming />}
          />

          <Route exact path="/case-studies" element={<CaseStudies />} />

          <Route exact path="/get-a-quote" element={<GetInTouch />} />

          <Route exact path="/request-a-demo" element={<RequestDemo />} />

          <Route
            exact
            path="/enhancing-supply-chain-efficiency-with-prime"
            element={<CaseStudiesOptimizing />}
          />

          <Route
            exact
            path="/streamlining-expense-managment-in-manufacturing-with-prime"
            element={<CaseStudiesStreamlining />}
          />

          <Route
            exact
            path="/enhancing-customer-experience-with-greetly"
            element={<CaseStudiesEnhancing />}
          />

          <Route
            exact
            path="/enhance-logistics-efficiency-and-customer-satisfaction-with-choice-touch"
            element={<CaseStudiesEnhancingLogisticsEfficiency />}
          />

          {/* <Route
            exact
            path="/products/telelyzer"
            element={<LendingLab />}
          /> */}
          <Route
            exact
            path="/products/insurance-management-system"
            element={<DriveAssure />}
          />
          <Route
            exact
            path="/products/employee-management-system"
            element={<ChoiceTouch />}
          />
          <Route
            exact
            path="/products/customer-engagement-platform"
            element={<CustomerEngagement />}
          />
          <Route
            exact
            path="/products/transport-management-system"
            element={<TransTrack />}
          />
          <Route
            exact
            path="/products/procurement-management-software"
            element={<ProcurementProcess />}
          />
          <Route
            exact
            path="/products/invoice-generation-software"
            element={<SimplifyingInvoicing />}
          />
          <Route
            exact
            path="/products/exployee-expenses-management-system"
            element={<PrimeEmpowering />}
          />
          <Route
            exact
            path="/services/web-development-services"
            element={<WebDevelopment />}
          />
            <Route
            exact
            path="/job-application"
            element={<ApplyForm />}
          />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default Routing;
